module.exports = __webpack_public_path__ + "3f7b6e216b24d6365beaa62b628be240.jpg";